import React from "react";

export default function FormField({
  label,
  helper,
  className = "",
  dir = "rtl",
  as = "input",
  ...props
}) {
  const sharedClass = [
    as === "textarea" ? "field-textarea" : "field-input",
    dir === "ltr" ? "input-ltr" : "input-rtl",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label className="field-wrap">
      {label ? <span className="field-label">{label}</span> : null}
      {as === "textarea" ? (
        <textarea className={sharedClass} {...props} />
      ) : (
        <input className={sharedClass} {...props} />
      )}
      {helper ? <span className="field-help">{helper}</span> : null}
    </label>
  );
}
